
<ng-container [ngSwitch]="isSyncInProgress" >

  <div style="display: flex; flex-direction: column; flex: 1 1 auto;">
    <span class="title-3">Le tue informazioni</span>
  </div>

  <div *ngSwitchCase="false" class="participant-detail__container">

    <ng-container *ngIf="participant">
      <p [ngSwitch]="!!participant.user.last_name && !isDummyName(participant.user.first_name)" >
        <strong>
          <span *ngSwitchCase="true">{{ participant.user.first_name }} {{ participant.user.last_name }}</span>
          <span class="text-medium" *ngSwitchDefault><i>unavailable</i></span>
        </strong>
      </p>
      <p [ngSwitch]="!!participant.email && !isDummyEmail(participant.user.username)" >
        <span *ngSwitchCase="true">{{ participant.user.username }}</span>
        <span class="text-medium" *ngSwitchDefault><i>unavailable</i></span>
      </p>

      <div style="border-bottom: solid 1px #bbb; height: 0; width: 100%; margin: 1rem 0;"></div>
      <strong>Utente attivo da</strong>
      <p>{{ participant.created | date:'mediumDate' :undefined :'it' }}</p>
      <div style="border-bottom: solid 1px #bbb; height: 0; width: 100%; margin: 1rem 0;"></div>

      <ng-container>
        <div *ngIf="purchase$ | async as purchase; else purchaseLoader">
          <strong>I tuoi premi</strong>
          <p>{{ purchase.length }} premi ottenuti</p>
          <br>
          <p style="text-align: right">
            <a
              [routerLink]="['/dashboard', 'participant', 'detail']"
            >Vedi di più</a>
          </p>
        </div>
        <ng-template #purchaseLoader>
          <div  class="bg-main">
            <app-loader></app-loader>
          </div>
        </ng-template>

      </ng-container>

    </ng-container>
  </div>

  <app-card-overlay
    *ngSwitchDefault
    title="Aggiornamento Informazioni"
    size="small"
  ></app-card-overlay>

</ng-container>
